// import './jquery/_parallax.js';

const breakpoint = 760;
const elementsToShow = document.querySelectorAll(".animate-on-scroll");
const header = document.getElementById("siteHeader");

let scroll =
  window.requestAnimationFrame ||
  function(callback) {
    window.setTimeout(callback, 1000 / 60);
  };

// forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

/**
 *
 *
 *
 */
const init = function() {
  loop();
};

/**
 *
 *
 *
 */
const loop = function() {
  adjustHeaderOnScroll();

  elementsToShow.forEach(element => {
    const baseClass = "animated";
    let desktopAnimation = element.getAttribute("data-desktop-animate");
    let mobileAnimation = element.getAttribute("data-mobile-animate");

    if (!mobileAnimation) {
      mobileAnimation = desktopAnimation;
    }

    if (!mobileAnimation && !desktopAnimation) {
      mobileAnimation = "fadeIn";
      desktopAnimation = "fadeIn";
    }

    if (element.classList.contains(baseClass)) {
      return;
    }

    if (isElementInViewport(element)) {
      if (getWindowWidth() >= breakpoint) {
        element.classList.add(baseClass);
        element.classList.add(desktopAnimation);
      } else {
        element.classList.add(baseClass);
        element.classList.add(mobileAnimation);
      }
    }
  });

  scroll(loop);
};

/**
 *
 *
 *
 */
const getWindowWidth = function() {
  const win = window;
  const doc = document;
  const docElem = doc.documentElement;
  const body = doc.getElementsByTagName("body")[0];
  const x = win.innerWidth || docElem.clientWidth || body.clientWidth;

  return x;
};

/**
 *
 *
 *
 */
const isElementInViewport = el => {
  var rect = el.getBoundingClientRect();

  return (
    (rect.top <= 0 && rect.bottom >= 0) ||
    (rect.bottom >=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.top <=
        (window.innerHeight || document.documentElement.clientHeight)) ||
    (rect.top >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight))
  );
};

/**
 *
 *
 *
 */
const adjustHeaderOnScroll = function() {
  var windowScrollTop =
    window.pageYOffset || document.documentElement.scrollTop;
  var className = "header--scrolled";

  if (windowScrollTop > 70) {
    if (!header.classList.contains(className)) {
      header.classList.add(className);
    }
  } else {
    if (header.classList.contains(className)) {
      header.classList.remove(className);
    }
  }
};

const api = {
  init: init
};

export default api;
